import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';
import { HeartFilledIcon } from 'src/domains/layouts/shared/assets/icons/HeartFilledIcon';
import { HeartOutlinedIcon } from 'src/domains/layouts/shared/assets/icons/HeartOutlineIcon';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { withConfig } from 'src/withConfig';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const GameInfoWrapper = withConfig(theme => styled('div', { label: 'GameInfoWrapper' })`
    background-color: ${theme.star.casino.gameInfo.bgColorQuaternary};
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    width: 100%;
`);

export const GameImageWrapper = styled('div', { label: 'GameImageWrapper' })`
    flex: 0 0 340px;
    height: 340px;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

export const GameImgWrapperLazy = withConfig(theme => styled(LazyImage, { label: 'GameImgWrapperLazy' })`
    height: 100%;
    width: 100%;
    &::before {
        background: ${theme.star.casino.gameInfo.bgColorSecondary};
    }
`);

export const FavouriteBar = withConfig(theme => styled('div', { label: 'FavouriteBar' })<{ isAddedToFavouritesConfirmation: boolean }>`
    backdrop-filter: blur(2px);
    background-color: ${({ isAddedToFavouritesConfirmation }): string => isAddedToFavouritesConfirmation ? theme.star.casino.gameInfo.bgColorQuinary : theme.star.casino.bgColorQuaternary};
    color: ${theme.star.casino.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    inset: auto 0 0;
    line-height: 1.4286;
    opacity: 0.8;
    opacity: ${({ isAddedToFavouritesConfirmation }): string => isAddedToFavouritesConfirmation ? theme.star.casino.gameInfo.favouriteBarOpacity : '0.8'};

    padding: 16px;
    position: absolute;
`);

const favouritiesBarIcon = (theme: EmotionTheme): SerializedStyles => css`
    fill: ${theme.star.casino.txtColor};
    width: 24px;
`;

export const HeartFilledIconWrapper = withConfig(theme => styled(HeartFilledIcon, { label: 'HeartFilledIconWrapper' })`
    ${favouritiesBarIcon(theme)};
`);

export const HeartOutlinedIconWrapper = withConfig(theme => styled(HeartOutlinedIcon, { label: 'HeartOutlinedIconWrapper' })`
    ${favouritiesBarIcon(theme)};
`);

export const CheckIconWrapper = withConfig(theme => styled(CheckSingleIcon, { label: 'CheckIconWrapper' })`
    ${favouritiesBarIcon(theme)};
    fill: ${theme.star.casino.gameInfo.txtColorTertiary};
`);

export const LikeBtn = styled('div', { label: 'LikeBtn' })`
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 8px;
    justify-content: center;
`;

export const LikeMessage = withConfig(theme => styled('div', { label: 'LikeMessage' })`
    align-items: center;
    animation: fade-in .5s;
    color: ${theme.star.casino.gameInfo.txtColorTertiary};
    display: flex;
    gap: 8px;
    justify-content: center;
    @keyframes fade-in {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
`);

const setGameInfoBtnWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.medium};
            padding: ${theme.star.padding.medium};
        `;
    }
    return css``;
};
interface GameInfoBtnWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}


export const GameInfoBtnWrapper = withConfig(theme => styled('div', { label: 'GameInfoBtnWrapper' })<GameInfoBtnWrapperPropsType>`
    ${({ variant }): SerializedStyles => setGameInfoBtnWrapper(variant, theme)}
    display: flex;
    flex-flow: row nowrap;
`);

interface PlayButtonPropsType {
    variant: DefaultComponentVariantType | null;
}

export const PlayBtn = withConfig(theme => styled(Button, { label: 'PlayBtn' })<PlayButtonPropsType>`
    color: ${theme.star.casino.gameInfo.txtColorQuaternary};
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.medium : '0'};
    flex: 1 1 50%;
`);

interface PlayDemoBtnPropsType {
    variant: DefaultComponentVariantType | null;
}

export const PlayDemoBtn = withConfig(theme => styled(Button, { label: 'PlayDemoBtn' })<PlayDemoBtnPropsType>`
    background-color: ${theme.star.casino.gameInfo.bgColor};
    color: ${theme.star.casino.gameInfo.txtColor};
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.medium : '0'};
    flex: 1 1 50%;
`);

export const GameInfoDescription = withConfig(theme => styled('p', { label: 'GameInfoDescription' })`
    color: ${theme.star.casino.gameInfo.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    margin: 16px 16px 0 16px;
    padding: 0 0 16px 0;
    border-bottom: 1px dashed ${theme.star.casino.gameInfo.borderColor};
    border-image: repeating-linear-gradient(to right, ${theme.star.casino.gameInfo.borderColor} 0 10px, transparent 10px 18px) 1;
`);

export const GameInfoStatisticsWrapper = styled('div', { label: 'GameInfoStatisticsWrapper' })`
    display: flex;
    flex-flow: row wrap;
    padding: 16px;
    &:empty {
        display: none;
    }
`;
